import React from 'react';
import { Filter, FilterOption } from './search_filters';
import FilterChip from './filter_chip';
import CoreLink from './core_link';
import { Location } from 'history';
import qs from 'qs';
import { MParticleEventName } from '../elog/mparticle_tracker';

interface IProps {
  filter: Filter;
  option: FilterOption;
  location: Location;
}

export default function DismissibleCategoryFilter({
  filter,
  option,
  location = null,
}: IProps) {
  const trackingData = {
    componentName: 'DismissibleCategoryFilter',
    eventName: MParticleEventName.ClickedDismissibleFilter,
    filter: filter.name,
    option: option.name,
  };

  const getDismissLink = () => {
    let dismissedParams;

    const removingSubcategory = option.paramName === 'category_slugs' && option.unsetValues.length === 1;
    const removingNestedSubcategory = option.paramName === 'category_slugs' && option.unsetValues.length > 1;
    const removingRootProductType = option.paramName === 'category_slugs' && option.unsetValues.length === 0;
    const onProductFamilyPage = location.pathname?.includes('/f/');

    if (onProductFamilyPage) {
      dismissedParams = { [option.paramName]: option.unsetValues };
    } else if (removingSubcategory) {
      dismissedParams = { category: [] };
    } else if (removingNestedSubcategory) {
      dismissedParams = { category: option.unsetValues[option.unsetValues.length - 1] };
    } else if (removingRootProductType) {
      dismissedParams = { product_type: option.unsetValues };
    }

    return {
      pathname: location.pathname,
      query: {
        ...qs.parse(location.search, { ignoreQueryPrefix: true }),
        ...dismissedParams,
      },
    };
  };

  return (
    <>
      <CoreLink
        to={getDismissLink()}
        clickEvent={trackingData}
        className="mr-1 mb-1"
      >
        <FilterChip
          dismissible
        >
          {option.name}
        </FilterChip>
      </CoreLink>
    </>
  );
}
